/**
 * Used for the Wordpress Pagebuilder
 */
export default function Edit() {
    return (
        <div>[DHL eCommerce ServicePoints]</div>
    );
}
